
class fun {
    constructor() {
     
    }
getClass(Class,ID)
{
  Class.forEach(Cl => {
    if (Cl[1]===ID) {
      console.log(Cl+"  "+ID)

      return Cl[0]
    }
  });
}

getInitials(name){
  let initials = name.split(' ');
  
  if(initials.length > 1) {
    initials = initials.shift().charAt(0) + initials.pop().charAt(0);
  } else {
    initials = name.substring(0, 2);
  }
  
  return initials.toUpperCase();
  
}

getDate(timestamp)
{
  let date= new Date(timestamp)
  return date.toLocaleDateString("sv-SE")//.toLocaleString()
}
getTime(timestamp)
{
  let date= new Date(timestamp)
  return date.toLocaleTimeString("sv-SE")//.toLocaleString()
}
getName(Id,teachernameandId,membernameandId) {
  let name = teachernameandId.find((x) => {
    if (x[1] == Id) {
      return x[0];
    }
  });
  if (name == null) {
    name = membernameandId.find((p) => {
      if (p[1] == Id) {
        return p[0];
      }
    });
    if (name == null) {
      name = "Okänd";
    }
  }
  return name[0];
}
}
// module.exports = fun;
export default fun
// export default;